namespace TabAurous.Inventory {
    export interface MaterialRequestForm {
        TransDate: Serenity.DateEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.LookupEditor;
        CompanyName: Serenity.StringEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.LookupEditor;
        TermsId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        ItemDetails: MaterialRequestItemsEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class MaterialRequestForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.MaterialRequest';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MaterialRequestForm.init)  {
                MaterialRequestForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;
                var w5 = MaterialRequestItemsEditor;
                var w6 = s.TextAreaEditor;

                Q.initFormType(MaterialRequestForm, [
                    'TransDate', w0,
                    'TransId', w1,
                    'VoucherNo', w1,
                    'VoucherTypeId', w2,
                    'PartyId', w3,
                    'CompanyName', w1,
                    'UserId', w3,
                    'EmployeeId', w3,
                    'TermsId', w2,
                    'BillNo', w1,
                    'BillDate', w0,
                    'ChallanNo', w1,
                    'ChallanDate', w0,
                    'CurrencyId', w3,
                    'ExchRate', w4,
                    'ItemDetails', w5,
                    'Pieces', w2,
                    'Weight', w4,
                    'NetWeight', w4,
                    'Remark', w6,
                    'NetAmount', w4,
                    'TaxAmount', w4,
                    'Discount', w4,
                    'AdditionalCharges', w4,
                    'GrossAmount', w4,
                    'ShipmentId', w2,
                    'ShipAddressId', w2,
                    'CompanyId', w2
                ]);
            }
        }
    }
}
